var map = {
	"./403_forbidden.png": "e994",
	"./403_forbidden.svg": "e528",
	"./404.png": "16f4",
	"./404.svg": "8a81",
	"./awesome.png": "b0a5",
	"./awesome.svg": "0215",
	"./code.png": "6a6c",
	"./completed.png": "10ca",
	"./completed.svg": "b907",
	"./css/main.css": "5aea",
	"./done.png": "406d",
	"./done.svg": "2e1f",
	"./ebay_logo.png": "21f7",
	"./empty.png": "1427",
	"./empty.svg": "8479",
	"./feeling_blue.png": "cac9",
	"./feeling_blue.svg": "8a30",
	"./high_five.png": "24af",
	"./high_five.svg": "de01",
	"./loading.svg": "4045",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo_bc.png": "e982",
	"./no_data.svg": "0d78",
	"./no_image.png": "f0e4",
	"./productsDB_access.png": "fea5",
	"./server_down.png": "db36",
	"./server_down.svg": "8363",
	"./server_status.png": "667d",
	"./server_status.svg": "13c4",
	"./shopify_logo.png": "ea4f",
	"./test.jpg": "724e",
	"./update.png": "090e",
	"./update.svg": "8124",
	"./void.png": "4f66",
	"./void.svg": "74184",
	"./welcome.png": "5d18",
	"./welcome.svg": "a50b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";